import { useMemo } from 'react'
import { useParams } from 'react-router-dom'
import { PageTabs } from '../../../../components'
import { CreatorRoutes } from '../../../CreatorRoutes'

interface IProps {}

const Header = () => {
  const { id } = useParams()

  const navigation = useMemo(
    () => [
      {
        text: 'Opportunities',
        count: null,
        to: CreatorRoutes.opportunities.replace(':id', `${id}`),
      },
      {
        text: 'Invitations',
        count: null,
        to: CreatorRoutes.invitations.replace(':id', `${id}`),
      },
    ],
    [id],
  )

  return (
    <div className='flex flex-col px-1'>
      <div className='grid grid-cols-1 lg:flex lg:flex-row lg:justify-between mt-5'>
        <div className='sm:w-0 sm:flex-1'>
          <h1 className='font-bold text-3xl font-outfit'>Opportunities</h1>
        </div>
      </div>

      {/* Navigation */}
      <PageTabs
        navigation={navigation}
        menuPosition='right'
        className='my-4 md:mt-0'
      />
    </div>
  )
}

export { Header }
